import React, { useEffect, useRef, useState } from 'react';
import { FaRegSmile } from 'react-icons/fa';
import { MESSAGE_EMOJIS } from '../../config/emojis';

/**
 * Composer-side emoji picker: appends an emoji to the message being typed.
 *
 * Distinct from `ReactionPicker`, which toggles a reaction ON a message and is
 * limited to the reaction set. This one is a plain text-insert affordance, so it
 * carries the wider set and opens UPWARDS — the composer sits at the bottom of
 * the pane, and a downward panel would open off-screen.
 */
const ComposerEmojiPicker = ({ onSelect, disabled = false, emojis = MESSAGE_EMOJIS }) => {
  const anchorRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (disabled) setIsOpen(false);
  }, [disabled]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onPointerDown = (event) => {
      if (!anchorRef.current?.contains(event.target)) setIsOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [isOpen]);

  return (
    <span className="composer-emoji-anchor" ref={anchorRef}>
      <button
        type="button"
        title="Emoji"
        aria-label="Emoji"
        aria-expanded={isOpen}
        disabled={disabled}
        className={`composer-icon-btn composer-emoji-btn ${isOpen ? 'is-open' : ''}`}
        onClick={() => setIsOpen((open) => !open)}
      >
        <FaRegSmile size={20} />
      </button>

      {isOpen && (
        <div className="floating-menu emoji-panel" role="menu">
          {emojis.map((emoji) => (
            <button
              key={emoji}
              type="button"
              role="menuitem"
              className="reaction-option"
              onClick={() => onSelect?.(emoji)}
            >
              {emoji}
            </button>
          ))}
        </div>
      )}
    </span>
  );
};

export default ComposerEmojiPicker;
